import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.marquee__splide' ).length ) {
        $( '.marquee__splide' ).each( function( index, element ) {
          // skip if already initialized from testimonial slider
          if ( $( element ).data( 'marquee-initialized' ) ) {
            return;
          }

          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: 'free',
            gap: '2rem',
            arrows: false,
            autoWidth: true,
            pagination: false,
            autoScroll: {
              speed: .75,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );

          const section = $( element );
          const sectionWidth = section.width();
          const doubleSectionWidth = sectionWidth * 2;
          let iterations = 0;
          const maxIterations = 10;
          let totalWidth = 0;
          const slides = section.find( `.splide__slide` );
          slides.each( function() {
            totalWidth += $( this ).width();
          } );

          while ( totalWidth < doubleSectionWidth && iterations < maxIterations ) {
            if ( totalWidth < doubleSectionWidth ) {
              slides.each( function() {
                // Clone each slide and append it to the marquee-track
                const clonedSlide = $( this ).clone();
                section.find( '.splide__list' ).append( clonedSlide );
                // Update the total width with the width of the cloned slide
                totalWidth += clonedSlide.width();
              } );
            }
            iterations++;
          }

          slider.mount( {AutoScroll} );
          $( element ).data( 'marquee-initialized', true );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'marquee', COMPONENT );
} )( app );
